"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _ErrorIcon = _interopRequireDefault(require("./ErrorIcon"));
var _excluded = ["id", "tabs", "value", "underline", "tabProps"],
  _excluded2 = ["id", "label", "labelKey", "path", "isErrorTab"];
var useUnderlineStyles = (0, _makeStyles.default)(function (theme) {
  return {
    badge: {
      backgroundColor: 'white',
      border: '1px solid red',
      borderRadius: '50%',
      height: '14px',
      minWidth: '0px',
      padding: '0px',
      right: '5px',
      top: '5px',
      width: '14px'
    },
    flexContainer: {
      [theme.breakpoints.down('md')]: {
        flexWrap: 'none',
        paddingInline: '12px'
      },
      position: 'relative',
      zIndex: 2
    },
    icon: {
      height: '10px',
      width: '10px'
    },
    indicator: {
      height: '2px',
      marginBottom: '6px'
    },
    scrollButtons: {
      '&.Mui-disabled': {
        opacity: '0.12 !important'
      }
    },
    selected: {
      color: "".concat(theme.palette.primary.main, " !important"),
      transition: '0.3s'
    },
    tab: {
      '&:hover': {
        backgroundColor: 'rgba(0, 119, 200, 0.12)',
        color: "".concat(theme.palette.primary.main, " !important")
      },
      borderBottom: '1px solid #0000001F',
      minHeight: '0px',
      minWidth: '0px',
      padding: '11.5px 12px',
      textTransform: 'none',
      transition: '0.3s'
    }
  };
});
var useFilledStyles = (0, _makeStyles.default)(function (theme) {
  return {
    badge: {
      backgroundColor: 'white',
      border: '1px solid red',
      borderRadius: '50%',
      height: '14px',
      minWidth: '0px',
      padding: '0px',
      right: '5px',
      top: '5px',
      width: '14px'
    },
    flexContainer: {
      [theme.breakpoints.down('md')]: {
        flexWrap: 'none'
      },
      [theme.breakpoints.up('md')]: {
        flexWrap: 'wrap'
      },
      gap: '8px',
      marginBlock: '9px',
      position: 'relative',
      zIndex: 2
    },
    icon: {
      height: '10px',
      width: '10px'
    },
    indicator: {
      height: '0%'
    },
    scrollButtons: {
      '&.Mui-disabled': {
        opacity: '0.12 !important'
      }
    },
    selected: {
      '&:hover': {
        backgroundColor: "".concat(theme.palette.primary.main, " !important"),
        color: "".concat(theme.palette.common.white, " !important")
      },
      backgroundColor: theme.palette.primary.main,
      borderRadius: 100,
      color: "".concat(theme.palette.common.white, " !important"),
      transition: '0.3s'
    },
    tab: {
      '&:hover': {
        backgroundColor: 'rgba(0, 119, 200, 0.12)',
        borderRadius: 100,
        color: theme.palette.primary.main
      },
      minHeight: '0px',
      minWidth: '0px',
      padding: '11.5px 12px',
      textTransform: 'none',
      transition: '0.3s'
    }
  };
});
var NavTabs = function NavTabs(_ref) {
  var domId = _ref.id,
    tabs = _ref.tabs,
    value = _ref.value,
    _ref$underline = _ref.underline,
    underline = _ref$underline === void 0 ? false : _ref$underline,
    _ref$tabProps = _ref.tabProps,
    tabProps = _ref$tabProps === void 0 ? {} : _ref$tabProps,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var isSmallScreen = (0, _material.useMediaQuery)(function (theme) {
    return theme.breakpoints.down('md');
  });
  var underlineClasses = useUnderlineStyles();
  var filledStyles = useFilledStyles();
  var classes = underline ? underlineClasses : filledStyles;
  return /*#__PURE__*/_react.default.createElement(_material.Tabs, (0, _extends2.default)({
    classes: {
      flexContainer: classes.flexContainer,
      indicator: classes.indicator,
      scrollButtons: classes.scrollButtons
    },
    id: "".concat(domId, "NavTabs"),
    indicatorColor: "primary",
    scrollButtons: isSmallScreen,
    value: value,
    variant: isSmallScreen ? 'scrollable' : 'standard'
  }, rest), tabs.map(function (_ref2, i) {
    var id = _ref2.id,
      label = _ref2.label,
      labelKey = _ref2.labelKey,
      path = _ref2.path,
      isErrorTab = _ref2.isErrorTab,
      tab = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
    return /*#__PURE__*/_react.default.createElement(_material.Tab, (0, _extends2.default)({
      key: id,
      classes: {
        root: classes.tab,
        selected: classes.selected
      },
      component: /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
        return isErrorTab ? /*#__PURE__*/_react.default.createElement(_material.Badge, {
          badgeContent: /*#__PURE__*/_react.default.createElement(_ErrorIcon.default, {
            className: classes.icon
          }),
          classes: {
            anchorOriginTopRight: classes.badge
          },
          id: "".concat(props.id, "Badge")
        }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, (0, _extends2.default)({}, props, {
          ref: ref,
          id: "".concat(props.id, "Link")
        }))) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, (0, _extends2.default)({}, props, {
          ref: ref,
          id: "".concat(props.id, "Link")
        }));
      }),
      id: "".concat(domId, "NavTabsTab").concat(i),
      label: labelKey ? /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: labelKey
      }) : label,
      to: path,
      value: id
    }, tabProps, tab));
  }));
};
var _default = exports.default = NavTabs;